<template>
  <div style="margin-top: 20px">
    <template v-if="isLoading === enumStatusLoad.LOADING">
      <LoadingOutlined />

      <a-typography-text> Подключение к QZ Tray </a-typography-text>
    </template>

    <a-alert
      message="Ошибка"
      type="error"
      show-icon
      style="width: 100%"
      v-else-if="isLoading === enumStatusLoad.ERROR"
    >
      <template #description>
        У вас не установлено или не запущено приложение QZ Tray для печати
        этикеток.
        <a-typography-link style="display: block">
          <a-flex gap="small">
            <a-button
              size="middle"
              @click="getQzTrayInstaller"
              style="display: flex; align-items: center"
              :loading="isLoadingQzTrayInstaller"
            >
              <template #icon>
                <FileTextTwoTone style="font-size: 20px" />
              </template>
              Скачать QZ Tray
            </a-button>
          </a-flex>
        </a-typography-link>
      </template>

      <template #action>
        <a-button size="small" danger @click="qzTrayStore.connectToQzTray">
          Повторить попытку подключения
        </a-button>
      </template>
    </a-alert>

    <a-alert
      message="Успешно"
      type="success"
      show-icon
      style="width: 100%"
      v-else-if="isLoading === enumStatusLoad.LOADED"
    >
      <template #description> Подключение к QZ Tray успешно. </template>

      <template #closeText>
        <a-button type="default"> Закрыть </a-button>
      </template>
    </a-alert>
  </div>
</template>
<script setup lang="ts">
import { enumStatusLoad } from "@/tools/enumStatusLoad";
import { FileTextTwoTone, LoadingOutlined } from "@ant-design/icons-vue";
import { useQzTrayStore } from "@/stores/qzTray/qzTrayStore";
import { computed, ref } from "vue";
import { createNotification } from "@/tools/notification";

const qzTrayStore = useQzTrayStore();

const isLoading = computed(() => qzTrayStore.printersLoadingStatus);
const isLoadingQzTrayInstaller = ref<boolean>(false);

const getQzTrayInstaller = async () => {
  isLoadingQzTrayInstaller.value = true;
  try {
    const responseData = await qzTrayStore.getQzTrayInstaller();

    // Create blob and download
    const blob = new Blob([responseData], {
      type: "application/vnd.microsoft.portable-executable",
    });
    const url = window.URL.createObjectURL(blob);

    // Extract filename from header
    const filename = "QzTrayInstaller.exe";

    // Trigger download
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    createNotification("error", "Ошибка загрузки файла");
    console.error("Ошибка при получении установщика QZ Tray:", error);
    throw error;
  } finally {
    isLoadingQzTrayInstaller.value = false;
  }
};
</script>

<style scoped lang="scss"></style>
